<!-- TEMPLATE CONTRACT: App Component owns the visible Angular template structure for src/app/app.component.html. -->
<router-outlet />
<ui-toast-outlet />
<ui-loader-outlet />
